// 中央氣象局 API 授權碼
const CWB_API_AUTH_CODE = "CWB-6C084B38-3BE0-4C5D-9FE3-56CE843D83D4";

export {
  CWB_API_AUTH_CODE,
}